const dni = [
  "Niedziela",
  "Poniedziałek",
  "Wtorek",
  "Środa",
  "Czwartek",
  "Piątek",
  "Sobota",
];
const miesiace = [
  "stycznia",
  "lutego",
  "marca",
  "kwietnia",
  "maja",
  "czerwca",
  "lipca",
  "sierpnia",
  "września",
  "października",
  "listopada",
  "grudnia",
];

const formatDate = (published: string) => {
  const date = new Date(published);
  const nrd = date.getDay();
  const nrm = date.getMonth();
  const dzien = date.getDate();
  return `${dni[nrd]}, ${dzien} ${miesiace[nrm]}`;
};

export { formatDate };
